import { atomWithStorage } from 'jotai/utils';
import { ATOM_PRODUCTION_SCHEDULE_REFETCH_KEY } from './atomConstants';

export const productionScheduleRefetchAtom = atomWithStorage<boolean>(
    ATOM_PRODUCTION_SCHEDULE_REFETCH_KEY,
    false,
    undefined,
    {
        getOnInit: true
    }
);
